import script from "./lang.vue?vue&type=script&setup=true&lang=js"
export * from "./lang.vue?vue&type=script&setup=true&lang=js"

import "./lang.vue?vue&type=style&index=0&id=c1997e70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1997e70"]])

export default __exports__